@layer module {
.statement-wrapper {
            display: grid;
            place-items: center;
    }

.statement-form .title {
            display: block;
            text-align: center;
    }

.statement-form .year-month {
            display: grid;
            grid-template-columns: 1fr 2fr;
            position: relative;
    }

.statement-form .period-wrap {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
    }

      @media (max-width: 599px) {
                .statement-form .year-month {
                        grid-template-columns: 1fr;
                    }
          }

      @media (max-width: 399px) {
                .statement-form .period-wrap {
                        grid-template-columns: 1fr;
                    }
          }
} // layer module










@layer app {
.statement-wrapper {
            width: $size-500;
            padding: $size-45 $size-25;
    }

.statement-form {
            margin: 0;
            padding: 0;
            width: 100%;
    }

.statement-form .title {
            padding: 0 $size-40;
            margin-bottom: $size-30;
    }

.statement-form .year-month {
            grid-gap: $size-20;
            margin-bottom: $size-30;
    }

.statement-form .period-wrap {
            width: 100%;
            grid-gap: $size-40;
            margin-bottom: $size-30;
    }

      @media (min-width: 400px) {
                .statement-wrapper {
                        padding: $size-40 $size-50;
                    }
          }

      @media (max-width: 600px) {
                .statement-wrapper {
                        width: 100%;
                    }
          }

      @media (max-width: 599px) {
                .statement-form .year-month {
                        grid-gap: $size-10;
                    }
          }

      @media (max-width: 399px) {
                .statement-form .period-wrap {
                        grid-gap: $size-10;
                    }
          }

.statement-form {
            background-color: var(--banky-white);
    }

.statement-form .title {
            color: var(--banky-black);
    }
} // layer app
